import React, { useEffect } from 'react';

const Blogs = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    return (
        <div data-aos="fade" data-aos-duration="2000" className='text-center min-h-screen text-green-600 font-Cormorant-Garamond'>
            <h2 className='text-xl lg:text-2xl  my-8 font-bold uppercase text-center'>Coming Soon !</h2>
        </div>
    );
};

export default Blogs;